// Filter-specific config, ported from renderers-filter.js. The bio-attribute range
// filters (Age/Height/Weight) a Filter module offers are ABSOLUTE ranges over the whole
// database — a Filter narrows the population, it isn't linked to a reference player (same
// reasoning as Rankings' RANKING_RANGE_FILTERS, and identical domains today). The prototype
// keeps its own copy per file rather than sharing this small config literal; kept separate
// here too so Filter's ranges can diverge from Rankings' without touching the other. Passed
// as the trailing `rangeFilters` arg to every StatsFilterKit range function so the same
// chip/slider machinery drives it.

import type { RangeFilterConfig } from "../engines/stats-filter-kit.js";
import { ageFromDob } from "./squad-view.js";
import { LIVE_RANGE_FILTERS } from "../live/stats-files.js";

export const FILTER_BIO_RANGE_FILTERS: RangeFilterConfig = {
  age: {
    label: "Age range",
    chipLabel: "Age",
    unit: "y",
    relative: false,
    domain: { min: 15, max: 42 },
    getValue: (p) => ageFromDob(p.dob ?? null),
  },
  height: {
    label: "Height range",
    chipLabel: "Height",
    unit: "cm",
    relative: false,
    domain: { min: 151, max: 185 },
    getValue: (p) => (typeof p.height === "number" ? p.height : null),
  },
  weight: {
    label: "Weight range",
    chipLabel: "Weight",
    unit: "kg",
    relative: false,
    domain: { min: 48, max: 81 },
    getValue: (p) => (typeof p.weight === "number" ? p.weight : null),
  },
};

// --- ?live=1 (the Stats files) -------------------------------------------------------

/** The live chips, in Ben's add-menu order: the ones the files have data for (as Ranking's).
 *  League waits for Q-010; Height, Weight and Preferred Foot stay hidden on real data (Q-013).
 *  Minutes is rules.md's chip for every module (no floor by default; added, it starts at 150+). */
export const LIVE_FILTER_CHIPS = ["league", "position", "club", "nationality", "foot", "age", "height", "weight", "minutes"] as const;

/** Ben's absolute ranges + the Minutes chip. Height / Weight stay in so a chip carried over from a
 *  saved dashboard still reads right (and honestly matches nobody: the files have no heights). */
export const LIVE_FILTER_RANGE_FILTERS: RangeFilterConfig = {
  ...FILTER_BIO_RANGE_FILTERS,
  minutes: LIVE_RANGE_FILTERS.minutes!,
};
